import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';

import { directPrintLabel, downloadLabel, printLabel } from '../../../../store/printing/print.actions';
import { usePrintSettings } from '../../core/hooks';
import { buildDefaultPrintSetting } from '../../../../containers/print-document-button-containers/core/buildDefaultPrintSetting';
import { DocumentType } from '../../../../enums/document-type';
import PrintDocumentMenuItem from '../../../../components/print-document-menu-item';

export const Label = ({ fulfillmentPlanId, fulfillments, userHasShippingRole }) => {
  const dispatch = useDispatch();
  const fulfillmentIds = useMemo(() => fulfillments.filter((f) => !!f.fulfillmentId).map((f) => f.fulfillmentId), [fulfillments]);
  const hasPrintedLabel = fulfillments.some((f) => f?.labelPrintedStatus?.isPrinted ?? false);
  const printableLabelFulfillments = fulfillments.filter((fulfillment) => fulfillment?.fulfillmentType?.toLowerCase?.() === 'shipment');
  const isDisabled = printableLabelFulfillments.length === 0 || !userHasShippingRole;
  const printSettings = usePrintSettings(DocumentType.Label.printSettingKey);
  const onClick = useCallback(() => {
    dispatch(printLabel([fulfillmentPlanId], fulfillmentIds, hasPrintedLabel, false, false));
  }, [dispatch, fulfillmentIds, fulfillmentPlanId, hasPrintedLabel]);
  const onDownload = useCallback(() => {
    dispatch(downloadLabel(fulfillmentIds, hasPrintedLabel, false));
  }, [dispatch, fulfillmentIds, hasPrintedLabel]);
  const onPrint = useCallback(() => {
    dispatch(directPrintLabel(fulfillmentIds, hasPrintedLabel, printSettings, false));
  }, [dispatch, fulfillmentIds, hasPrintedLabel, printSettings]);
  const defaultPrintSetting = useMemo(
    () => buildDefaultPrintSetting(printSettings, onPrint, onDownload),
    [onDownload, onPrint, printSettings],
  );

  return (
    <PrintDocumentMenuItem
      defaultPrintSetting={defaultPrintSetting}
      disabled={isDisabled}
      name={DocumentType.Label.documentNameTranslation}
      onClick={onClick}
    />
  );
};

Label.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  fulfillments: PropTypes.array.isRequired,
  userHasShippingRole: PropTypes.bool.isRequired,
};
